var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "training-row",
      class: {
        hovered: _vm.hovered,
        selected: _vm.isSelected,
        multiSelectMode: _vm.multiSelectMode,
      },
      on: {
        mouseover: function ($event) {
          return _vm.changeHoverState(true)
        },
        mouseleave: function ($event) {
          return _vm.changeHoverState(false)
        },
        click: function () {
          return _vm.onSelectChanged(_vm.row._id)
        },
      },
    },
    [
      _vm.hovered || _vm.multiSelectMode
        ? _c(
            "div",
            { staticClass: "checkbox" },
            [
              _c("a-checkbox", {
                attrs: { checked: _vm.isSelected },
                on: {
                  change: function (e) {
                    return _vm.onSelectChanged(_vm.row._id)
                  },
                  click: function () {
                    return _vm.onSelectChanged(_vm.row._id)
                  },
                },
              }),
            ],
            1
          )
        : _c("div", { staticClass: "quote" }, [
            _c("span", { staticClass: "material-icons" }, [
              _vm._v(" format_quote "),
            ]),
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "phrase" }, [
        _c(
          "span",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { followCursor: true, placement: "top-center" },
                expression: "{ followCursor: true, placement: 'top-center' }",
              },
            ],
            attrs: { content: _vm.row.text },
          },
          [_vm._v(_vm._s(_vm.row.text))]
        ),
        _vm._v(" "),
        _vm.row.conversation &&
        _vm.hovered &&
        !_vm.multiSelectMode &&
        _vm.row.conversation
          ? _c(
              "a",
              {
                attrs: { href: "" },
                on: {
                  click: function (e) {
                    return _vm.gotoArchive(e, _vm.row)
                  },
                },
              },
              [_vm._v("( " + _vm._s(_vm.$t("chatbotv2.goToChat")) + ")")]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.hovered || _vm.multiSelectMode
        ? _c("div", { staticClass: "date" }, [
            _vm._v(_vm._s(_vm.timeHumanized())),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.hovered || _vm.multiSelectMode
        ? _c("div", { staticClass: "unmatched" }, [
            _c("div", { staticClass: "unmatched-value" }, [
              _vm._v(
                "\n            " + _vm._s(_vm.row.unmatched) + "\n        "
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hovered && !_vm.multiSelectMode
        ? _c(
            "div",
            { staticClass: "actions" },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { followCursor: true, placement: "bottom-end" },
                      expression:
                        "{ followCursor: true, placement: 'bottom-end' }",
                    },
                  ],
                  attrs: { content: "AiTrain" },
                  on: {
                    click: function () {
                      return (_vm.aiFaqModalVisible = true)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v(" smart_toy "),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-popover",
                {
                  attrs: {
                    visible: _vm.trainFormVisible,
                    overlayClassName: "no-padding",
                    placement: "bottom",
                    trigger: "click",
                  },
                  on: {
                    visibleChange: function (isVisible) {
                      return (_vm.trainFormVisible = isVisible)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "content" }, slot: "content" },
                    [
                      _c("TrainForm", {
                        attrs: {
                          "all-stories": _vm.stories,
                          "default-selected-story-id": _vm.row.story,
                          "on-cancel": function () {
                            return (_vm.trainFormVisible = false)
                          },
                          "on-train": _vm.startTrain,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      attrs: { content: "Train" },
                      on: { click: _vm.toggleTrainForm },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v(" done "),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { followCursor: true, placement: "bottom-end" },
                      expression:
                        "{ followCursor: true, placement: 'bottom-end' }",
                    },
                  ],
                  attrs: { content: "Ignore" },
                  on: { click: _vm.ignoreItem },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v(" visibility_off "),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { followCursor: true, placement: "bottom-end" },
                      expression:
                        "{ followCursor: true, placement: 'bottom-end' }",
                    },
                  ],
                  attrs: { content: _vm.$t("message.delete") },
                  on: { click: _vm.deleteItem },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v(" close "),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.aiFaqModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                className: "ai-destroy-modal",
                showFooter: false,
                showTitle: false,
              },
              on: {
                cancel: function () {
                  return (_vm.aiFaqModalVisible = false)
                },
              },
            },
            [
              _c("AIKnowledgeCreateForm", {
                attrs: {
                  title: "Question",
                  description: "Answer",
                  "question-item": [{ text: _vm.row.text }],
                },
                on: { faqCreated: _vm.faqCreated },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }